import { ButtonTypeConfig } from './types';

export const buttonTypeToClasses: ButtonTypeConfig = {
  primary: 'bg-primary text-white hover:bg-blue-200 focus:bg-blue-200 duration-200',
  secondary:
    'text-dark bg-transparent hover:bg-grey-100 focus:bg-grey-100 border-2 border-grey-200 font-normal duration-200',
  light: 'text-grey-500 bg-transparent border-0 font-normal'
};
